<template>
	<div class="userManagementError">
		<Notification :notification-mode="'error'">
			<template v-slot:title>{{ errorTitle }}</template>
			<template v-slot>{{ errorBody }}</template>
			<template v-slot:footer>
				<Button :button-type="'button'"
						class="loginRedirectButton"
						:button-style="'buttonText'"
						@on-click="redirectToLogin()"
				>
					Back to Login
				</Button>
			</template>
		</Notification>
	</div>
</template>

<script>
import Notification from './shared/Notification.vue';
import Button from './shared/Button.vue';
import { mapGetters } from 'vuex';

export default {
	components: { Notification, Button },

	computed: mapGetters ([
		'errorTitle',
		'errorBody'
	]),

	methods: {
		redirectToLogin() {
			window.location.assign('/login');
		}
	}
};
</script>

<style lang="scss" scoped>
.userManagementError {
	max-width: 960px;
	margin: 120px auto;
	padding-bottom: 150px;
	text-align: center;
}

.notification {
	display: inline-block;
	width: fit-content;
}

.notificationFooter {
	text-align: left;
}

.loginRedirectButton {
	padding-top: 15px;
	padding-bottom: 0px;
	padding-left: 0px;
	display: -webkit-box;
	text-align: left;
	margin: 0px;
	border: 0px;
}
</style>